import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import { submitDavinFoodsQuiz } from "../../redux/actions/index";

const EvacuationQuiz = ({ appData, submitQuiz }) => {
  const fullName = `${appData.firstName} ${appData.lastName}`;
  const quizName = "evacuationQuiz";
  const onboarding = appData.davinFoodsOnboarding;

  const initialData = {
    name: fullName,
    signature: fullName,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <p className="mb-2 text-center font-weight-bold">
          Please complete the Fire Controls and Evacuation at Davin Foods quiz
          as part of your induction with Reynolds.
        </p>
      ),
    },
    discover: {
      title: "1. What is the first thing you should do if you discover a fire?",
      value: getVal("discover"),
      type: "radio",
      radioOptions: [
        "Raise the alarm by shouting 'Fire' and activating the nearest fire call point",
        "Telephone the Safety Manager",
        "Inform your Line Manager",
        "All of the above",
      ],
      mandatory: true,
    },
    extinguishers: {
      title: "2. Who is allowed to use the fire extinguishers?",
      value: getVal("extinguishers"),
      type: "radio",
      radioOptions: [
        "Anyone",
        "First Aiders",
        "Managers",
        "Only the Fire Marshalls",
      ],
      mandatory: true,
    },
    assembly: {
      title:
        "3. Where are the two Fire Assembly Points at Davin Foods? (Select 2 answers)",
      value: getVal("assembly"),
      type: "multivalueCheckbox",
      selectOptions: [
        { label: "Main Building Smoking Area", value: "A" },
        {
          label: "Main Building Entrance",
          value: "B",
        },
        { label: "Fruit Room Yard by the Gate", value: "C" },
        { label: "Fruit Room Canteen", value: "D" },
      ],
      mandatory: true,
    },
    premises: {
      title:
        "4. What must you do every time you arrive to or leave the premises?",
      value: getVal("premises"),
      type: "radio",
      radioOptions: [
        "Sign in and out on the paper Fire Register",
        "Get a coffee for the journey",
        "Check you have your bag",
        "Change your shoes",
      ],
      mandatory: true,
    },
    prevent: {
      title: "5. How can we prevent a fire?",
      value: getVal("prevent"),
      type: "radio",
      radioOptions: [
        "Smoke only in designated smoking area",
        "Remove waste from the building regularly",
        "Do not block fire exits and fire extinguishers",
        "All of the above",
      ],
      mandatory: true,
    },
    name: {
      key: "name",
      title: "Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const completed =
    onboarding[quizName] &&
    (onboarding[quizName].status === "Pass" ||
      onboarding[quizName].retries === 0);
  const redirectBack = () =>
    history.push("/profile/edit/davin-foods-onboarding");
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitQuiz(quizName, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };
  return (
    <>
      {completed ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={
            "Fire Controls and Evacuation Induction at Davin Foods Quiz (PR906)"
          }
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"davinFoods"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};
EvacuationQuiz.propTypes = {
  appData: any,
  submitQuiz: func,
};
const mapDispatchToProps = {
  submitQuiz: submitDavinFoodsQuiz,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(EvacuationQuiz);
